import { render, staticRenderFns } from "./IconMap.vue?vue&type=template&id=1cd091e5&scoped=true&"
import script from "./IconMap.vue?vue&type=script&lang=js&"
export * from "./IconMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd091e5",
  null
  
)

export default component.exports